//
// DataNameToDataRendererModels.js
// gtl
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../../lib";
import "../../core/GTLModel";
import "../../core/DataRendererModel";

var DataNameToDataRendererModels = createModule("gtl::DataNameToDataRendererModels", ["commons::PropertyOwner","commons::BaseModel","gtl::GTLModel"], EventDispatcher, [
    ,
    {
        dataName: 7,
        dataRendererModels: [1],
    },
    ,
    ,
    ,
    {
        _create: [4],
    },
    ,
]);
export default DataNameToDataRendererModels;
